//account history constants

export const GET_ACCOUNT_HISTORY_ATTEMPT = "GET_ACCOUNT_HISTORY_ATTEMPT";
export const GET_ACCOUNT_HISTORY_SUCCESS = "GET_ACCOUNT_HISTORY_SUCCESS";
export const GET_ACCOUNT_HISTORY_FAILURE = "GET_ACCOUNT_HISTORY_FAILURE";
export const CLEAR_ACCOUNT_HISTORY_STATE = "CLEAR_ACCOUNT_HISTORY_STATE";

export const CLEAR_STATE = "CLEAR_STATE";
